import shopifyInfoService from '@/services/shopifyInfo';

export default {
  name: 'shopifyWelcome',
  data() {
    return {
      isLoading: true,

      shopifyInfo: null
    };
  },

  methods: {
    async getShopifyIntegrationDetails() {
      try {
        let response = await shopifyInfoService.getDetails();
        this.shopifyInfo = response.data.data;
        console.log('Shopify Integration Details', response.data);
        this.isLoading = false;
      } catch (error) {
        this.errorToast(`Something's not right. Please contact support team.`);
        console.error('Error in getting shopify integration details', error);
      }
    }
  },

  beforeDestroy() {
    document.getElementById('subSideMenu').style.display = 'block';
  },

  mounted() {
    document.getElementById('subSideMenu').style.display = 'none';
    this.getShopifyIntegrationDetails();
  }
};
